import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { UserSecurityService } from './../../../services/common/user-security.service';

import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from './../../../common/constants/master-constants';
import { tableHeader } from '../../../models/AccountDetailsVM';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-user-security',
  templateUrl: './user-security.component.html',
  styleUrls: ['./user-security.component.scss']
})

export class UserSecurityComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  export: boolean;
  validateEvolveData: any;
  filterArray = [];
  addToAccountVisible = true;
  filter: any;
  headerYear: any;
  headerCompany: any;
  userMenuAccessList: any;
  accessTypeMode = false;

  // set table header data
  headerList: tableHeader[] = [];
  ApiData: any[];

  // data souce list
  dataSourceList: any[];

  accounts: number[] = [];
  headerSubscription: any;
  accountTypeMap = {
    C: 'CUSTOMER PARENT',
    CB: 'CUSTOMER BILL TO ONLY',
    CC: 'COUNTER SALE CUSTOMER',
    CD: 'CUSTOMER DELIVER TO ONLY',
    CS: 'CUSTOMER SHIP TO',
    CP: 'CUSTOMER GRANDPARENT',
    E: 'EMPLOYEE',
    EC: 'EMPLOYEE CONTRACTOR',
    V: 'VENDOR',
    XC: 'INACTIVE CUSTOMER PARENT',
    XCB: 'INACTIVE CUSTOMER BILL TO ONLY',
    XCC: 'INACTIVE COUNTER SALE CUSTOMER',
    XCD: 'INACTIVE CUSTOMER DELIVER TO ONLY',
    XCP: 'INACTIVE CUSTOMER GRANDPARENT',
    XCS: 'INACTIVE CUSTOMER SHIP TO',
    XV: 'INACTIVE VENDOR'
  };
  constructor(private userSecurityService: UserSecurityService,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private router: Router) {
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    this.getAccountData(null);
    this.validateEvolve();
    
    this.filterArray = [
      { label: 'Account Name', column: 'accountName' },
      { label: 'Account Number', column: 'account' },
      { label: 'Account Type', column: 'accountTypeDescriptionWithCode' },
      { label: 'City', column: 'city' },
      { label: 'State / Province', column: 'state' }
    ];
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // On sigle row
  TableRowChecked(e: any) {
    if (e.event == 'rowChecked' && e.rowData) {
      this.accounts = this.accounts.filter(x => x != e.rowData.account);
      const row = e.rowData;
      if (row.isAccountSelected === true) {
        this.accounts.push(row.account);
      }
    }
  }

  // On select all
  AllRowChecked(e: any) {
    this.accounts = [];
    if (e.event == 'allRowChecked' && e.eventData.checked) {
      this.accounts = [];
      this.dataSourceList.forEach(x => {
        this.accounts.push(x.account);
      });
    }
  }

  // Export button
  onExportBtnClick(e: any) {
    this.export = !this.export;
  }

  // Validate evolve
  validateEvolve() {
    this.subscription.push(this.userSecurityService.validateEvolve().subscribe(results => {
      // filled data source with API data
      this.validateEvolveData = results;
      this.setHeaderAndTable();
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  // UPDATED: Set header and table with Account Type column
  setHeaderAndTable() {
    let sessionData;
    if (this.headerCompany == undefined) {
      sessionData = this.validateEvolveData.resultData[0];
    }
    else {
      sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    }

    this.headerList = [];
    if (!sessionData.evolveAccountRestriction) {
      this.headerList = [
        { headertxt: 'checkboxHeader', columnfield: 'isAccountSelected', className: 'mat-header-cell accountCheck' },
        { headertxt: 'Account', columnfield: 'account', className: 'mat-header-cell accountName accountId' },
        { headertxt: 'Account Name', columnfield: 'accountName', className: 'mat-header-cell accountName' },
        { headertxt: 'Account Type', columnfield: 'accountTypeDescription', className: 'mat-header-cell accountType' }, 
        { headertxt: 'City', columnfield: 'city', className: 'mat-header-cell accountCity' },
        { headertxt: 'B2B Enabled', columnfield: 'wfusB2BEnablement', className: 'mat-header-cell bTobEnabled' },
        { headertxt: 'State/Province', columnfield: 'state', className: 'mat-header-cell accountState' }

      ];
      this.addToAccountVisible = true;
    }
    else {
      this.headerList = [
        { headertxt: 'Account', columnfield: 'account', className: 'mat-header-cell accountId' },
        { headertxt: 'Account Name', columnfield: 'accountName', className: 'mat-header-cell accountName' },
        { headertxt: 'Account Type', columnfield: 'accountTypeDescription', className: 'mat-header-cell accountType' }, 
        { headertxt: 'City', columnfield: 'city', className: 'mat-header-cell accountCity' },
        { headertxt: 'B2B Enabled', columnfield: 'wfusB2BEnablement', className: 'mat-header-cell bTobEnabled' },
        { headertxt: 'State/Province', columnfield: 'state', className: 'mat-header-cell accountState' }
      ];
      this.addToAccountVisible = false;
    }
  }

  // Get Account data
  getAccountData(data: any) {
    this.loaderService.setLoaderStatus(true);

    if (data == null) {
      data = {};
    }

    this.subscription.push(this.userSecurityService.getAccountList(data).subscribe(results => {
      if (results) {
        // filled data source with API data
        this.dataSourceList = results as any[];
        
        // two separate properties
        this.dataSourceList = this.dataSourceList.map(row => {
          const accountTypeCode = (row.accountType || '').trim().toUpperCase();
          const accountTypeDesc = this.accountTypeMap[accountTypeCode] || '';
          return {
            ...row,
            accountTypeDescription: accountTypeDesc, // For grid display - description only
            accountTypeDescriptionWithCode: accountTypeDesc ? `${accountTypeDesc} - ${accountTypeCode}` : accountTypeCode // For filter dropdown
          };
        });
        
        this.ApiData = this.dataSourceList; // Store mapped data
        this.accounts = [];

        this.dataSourceList.forEach(row => {
          if (row.isAccountSelected === true) {
            this.accounts.push(row.account);
          }
        });

        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
          const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
          let activeUser = validateEvolveData.resultData[0];
          if (this.headerCompany) {
            activeUser = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          }

          if (activeUser) {
            if (this.accounts.length > 0) {
              // Check count
              validateEvolveData.resultData.forEach(x => {
                if (x.userIdCompanyCode == this.headerCompany) { x.isSetAccount = true; }
              });
            }
            else {
              validateEvolveData.resultData.forEach(x => {
                if (x.userIdCompanyCode == this.headerCompany) { x.isSetAccount = false; }
              });
            }
            this.localStorageService.set(MasterConstants.EVOLVE_ACCESS, JSON.stringify(validateEvolveData));
          }
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Save account
  saveAddToAccount(e: any, isAccountReset: boolean) {
    if (this.accounts) {
      const title = (this.accounts.length == 0) ? 'No record selected, do you want to update it.' :
        'Do you want to update ' + this.accounts.length + ' selected Accounts?';

      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.push(this.userSecurityService.saveAddToAccount(isAccountReset, this.accounts).subscribe(results => {
            let sessionData;

            if (this.headerCompany == undefined) {
              sessionData = this.validateEvolveData.resultData[0];
            }
            else {
              sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
            }

            if (sessionData.evolveAccountRestriction) {
              this.filter = null;
            }
            this.loaderService.setLoaderStatus(false);
            this.getAccountData(this.filter);
            this.accounts = [];
            this.broadcastService.broadcast(this.configService.HIDE_SHOW_COI_MENU, { checkHideShow: true });
            this.broadcastService.broadcast(this.configService.SRO_ACCESS);
            this.broadcastService.broadcast(this.configService.SRO_APROVERS_ACCESS);
            this.broadcastService.broadcast(this.configService.EDLP_ACCESS);
          }));
        }
      }));
    }
  }

  // UPDATED: Filter Grid to support Account Type filtering
  filterGrid(e: any) {
    let sessionData;

    if (this.headerCompany == undefined) {
      sessionData = this.validateEvolveData.resultData[0];
    }
    else {
      sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    }

    if (sessionData.evolveAccountRestriction) {
      if (e) {
        const accountNo = e.accountNo ? e.accountNo.split(',') : [];
        const accountName = e.accountName ? e.accountName.split(',') : [];
        const accountType = e.accountTypeDescriptionWithCode
          ? (Array.isArray(e.accountTypeDescriptionWithCode) ? e.accountTypeDescriptionWithCode : e.accountTypeDescriptionWithCode.split(','))
          : [];
        const city = e.city ? e.city.split(',') : [];
        const state = e.state ? e.state : [];

        this.dataSourceList = this.ApiData.filter(x => {
          //  Match exactly on the selected Account Type code (dropdown binds the code value)
          const accountTypeMatch = accountType.length > 0 
            ? accountType.find(y => (x.accountType || '').toLowerCase().trim() === y.toLowerCase().trim())
            : true;

          return (
            (accountNo.length > 0 ? accountNo.find(y => x.account == +(y.trim())) : true) &&
            (accountName.length > 0 ? accountName.find(y => (x.accountName.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
            accountTypeMatch &&
            (city.length > 0 ? city.find(y => (x.city.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true) &&
            (state.length > 0 ? state.find(y => (x.state.toLowerCase().indexOf(y.toLowerCase().trim())) !== -1) : true)
          );
        });
      }
      else {
        this.dataSourceList = this.ApiData;
      }
    }
    else {
      if (e == null) {
        this.filter = null;
      }
      else {
        //  Extract account type codes before sending to backend
        let accountTypeCodes = '';
        if (e && e.accountTypeDescriptionWithCode && e.accountTypeDescriptionWithCode.length > 0) {
          const accountTypeValues = Array.isArray(e.accountTypeDescriptionWithCode)
            ? e.accountTypeDescriptionWithCode
            : e.accountTypeDescriptionWithCode.split(',');
          const codes = accountTypeValues.map(value => {
            const parts = value.trim().split(' - ');
            // Return the last part (code) if format is "DESC - CODE", otherwise return as-is
            return parts.length > 1 ? parts[parts.length - 1] : value.trim();
          });
          accountTypeCodes = codes.join(',');
        }
        this.filter = {
          AccountName: (e && e.accountName) ? e.accountName : '',
          Account: (e && e.accountNo) ? e.accountNo : '',
          AccountType: accountTypeCodes, 
          AccountCity: (e && e.city) ? e.city : '',
          AccountState: (e && e.state) ? e.state.join(',') : ''
        };
      }
      this.getAccountData(this.filter);
    }
  }
}
